import React, { useContext } from 'react';

import { observer } from 'mobx-react';
import ModalStore, { ModalTypes } from 'src/stores/ModalStore';
import CreateEventModal from 'src/components/CreateEventModal';
import EncounterModal from 'src/components/EncounterModal';
import CenterModal from 'src/components/CenterModal';
import SideModal from 'src/components/SideModal';
import ModalHeader from 'src/components/ModalHeader';
import CreateNeedModal from 'src/components/CreateNeedModal';
import CreateNoteModal from 'src/components/CreateNoteModal';
import CreateAttachmentModal from 'src/components/CreateAttachmentModal';
import ConfirmationModal from 'src/components/ConfirmationModal';
import CreatePatientModal from 'src/components/CreatePatientModal';
import CreateMedicationModal from 'src/components/CreateMedicationModal';
import CreateScheduledJobModal from 'src/components/CreateScheduledJobModal';
import ViewContentModal from 'src/components/ViewContentModal';
import { DiscreteFormModal } from 'src/components/DiscreteFormModal';
import EncounterFormDetailsModal from 'src/components/EncounterFormDetailsModal';
import AdminFlowScriptTemplateModal from 'src/components/AdminFlowScriptTemplateModal';
import AdminImportBatchTemplateModal from 'src/components/AdminImportBatchTemplateModal';
import CreateImportModal from 'src/components/CreateImportModal';
import ImportBatchRecordModal from 'src/components/ImportBatchRecordModal';
import ProviderModal from 'src/components/ProviderModal';
import FacilityModal from 'src/components/FacilityModal';
import FacilityCloneWizard from 'src/components/FacilityCloneWizard';
import SubmitToQcdrModal from 'src/containers/Reports/Macra/Modals/SubmitToQcdrModal';
import VitalsConnectionModal from 'src/components/VitalsConnectionModal';
import AdminAuth0UserStatusModal from 'src/components/AdminAuth0UserStatusModal';
import CustomerModal from 'src/components/CustomerModal';
import CustomerDocumentModal from 'src/components/CustomerDocumentModal';
import AutomatedDispenseSystemModal from 'src/components/AutomatedDispenseSystemModal';
import CustomerContactModal from 'src/components/CustomerContactModal/CustomerContactModal';
import CustomerStatusModal from 'src/components/CustomerStatusModal';
import FacilitySubscriptionDataModal from 'src/components/FacilitySubscriptionDataModal';
import CreateOrganizationModal from 'src/components/CreateOrganizationModal';
import EditOrganizationEntitlementsModal from 'src/components/EditOrganizationEntitlementsModal';
import MacraAQIExportModal from 'src/components/MacraAQIExportModal';
import FormModelModal from 'src/components/FormModelModal';
import FormCatalogModal from 'src/components/FormCatalogModal';
import FormAssetModal from 'src/components/FormAssetModal';
import FormCatalogPageModal from 'src/components/FormCatalogPageModal';
import FormCatalogVersionModal from 'src/components/FormCatalogVersionModal';
import FormFacilityMappingModal from 'src/components/FormFacilityMappingModal';
import SetUserNpiModal from 'src/components/SetUserNpiModal';

export function ModalHandler() {
    const modalStore = useContext(ModalStore);
    const { type, props } = modalStore.modalOptions;

    switch (type) {
        case ModalTypes.CreateEvent:
            return <CreateEventModal {...props} />;
        case ModalTypes.Encounter:
            return <EncounterModal {...props} />;
        case ModalTypes.AddEncounterForm:
            return (
                <SideModal isOpen={true} isWide={true} onClose={props.onClose}>
                    <ModalHeader title="Add Form" onClose={props.onClose} />
                    <DiscreteFormModal {...props} onClose={props.onClose} />
                </SideModal>
            );
        case ModalTypes.EditEncounterForm:
            return (
                <SideModal isOpen={true} isWide={true} onClose={props.onClose}>
                    <ModalHeader title="Edit Form" onClose={props.onClose} />
                    <DiscreteFormModal {...props} onClose={props.onClose} />
                </SideModal>
            );
        case ModalTypes.PatientNeed:
            return <CreateNeedModal {...props} />;
        case ModalTypes.PatientNote:
            return <CreateNoteModal {...props} />;
        case ModalTypes.PatientAttachment:
            return <CreateAttachmentModal {...props} />;
        case ModalTypes.ConfirmationModal:
            return <ConfirmationModal {...props} />;
        case ModalTypes.CreatePatient:
            return <CreatePatientModal {...props} />;
        case ModalTypes.PatientMedication:
            return <CreateMedicationModal {...props} />;
        case ModalTypes.CreateScheduledJob:
            return <CreateScheduledJobModal {...props} />;
        case ModalTypes.ViewContent:
            return <ViewContentModal {...props} />;
        case ModalTypes.EncounterFormRawDetails:
            return <EncounterFormDetailsModal {...props} />;
        case ModalTypes.CreateFlowScriptTemplate:
            return <AdminFlowScriptTemplateModal {...props} />;
        case ModalTypes.CreateImportBatchTemplate:
            return <AdminImportBatchTemplateModal {...props} />;
        case ModalTypes.CreateImportModal:
            return <CreateImportModal {...props} />;
        case ModalTypes.ImportBatchRecord:
            return <ImportBatchRecordModal {...props} />;
        case ModalTypes.Provider:
            return <ProviderModal {...props} />;
        case ModalTypes.Facility:
            return <FacilityModal {...props} />;
        case ModalTypes.FacilityCloneWizard:
            return <FacilityCloneWizard {...props} />;
        case ModalTypes.SubmitToQcdrModal:
            return <SubmitToQcdrModal {...props} />;
        case ModalTypes.VitalsConnectionModal:
            return <VitalsConnectionModal {...props} />;
        case ModalTypes.AdminAuth0UserStatusModal:
            return <AdminAuth0UserStatusModal {...props} />;
        case ModalTypes.CustomerModal:
            return <CustomerModal {...props} />;
        case ModalTypes.CustomerDocumentModal:
            return <CustomerDocumentModal {...props} />;
        case ModalTypes.AutomatedDispenseSystemModal:
            return <AutomatedDispenseSystemModal {...props} />;
        case ModalTypes.CustomerContactModal:
            return <CustomerContactModal {...props} />;
        case ModalTypes.CustomerStatusModal:
            return <CustomerStatusModal {...props} />;
        case ModalTypes.FacilitySubscriptionDataModal:
            return <FacilitySubscriptionDataModal {...props} />;
        case ModalTypes.CreateOrganizationModal:
            return <CreateOrganizationModal {...props} />;
        case ModalTypes.EditOrganizationEntitlementsModal:
            return <EditOrganizationEntitlementsModal {...props} />;
        case ModalTypes.MacraAQIExportModal:
            return <MacraAQIExportModal {...props} />;
        case ModalTypes.FormModelModal:
            return <FormModelModal {...props} />;
        case ModalTypes.FormCatalogModal:
            return <FormCatalogModal {...props} />;
        case ModalTypes.FormAssetModal:
            return <FormAssetModal {...props} />;
        case ModalTypes.FormCatalogPageModal:
            return <FormCatalogPageModal {...props} />;
        case ModalTypes.FormCatalogVersionModal:
            return <FormCatalogVersionModal {...props} />;
        case ModalTypes.FormFacilityMappingModal:
            return <FormFacilityMappingModal {...props} />;
        case ModalTypes.SetUserNpiModal:
            return <SetUserNpiModal {...props} />;
        default:
            break;
    }
    return null;
}
export default observer(ModalHandler);
